import { memo } from "react";
import { motion } from "framer-motion";
import { CheckCheck } from "lucide-react";

const Bubble = memo(({ msg, i, animate }) => (
  <motion.div initial={animate ? { opacity: 0, y: 8 } : false} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.25 }}
    className={`flex ${msg.role === "user" ? "justify-end" : "justify-start"}`} data-testid={`chat-message-${msg.role}-${i}`}>
    {msg.role === "assistant" && (
      <img src="/logo.jpg" alt="" width="32" height="32" className="w-8 h-8 rounded-full object-cover mr-2 mt-1 flex-shrink-0 shadow-sm" />
    )}
    <div className={`max-w-[82%] px-4 py-3 text-sm leading-relaxed ${
      msg.role === "user" ? "chat-bubble-user rounded-2xl rounded-br-md" : "chat-bubble-ai rounded-2xl rounded-bl-md text-gray-800"
    }`}>
      <span className="whitespace-pre-line break-words">{msg.content}</span>
      {msg.role === "assistant" && (
        <div className="flex items-center justify-end gap-1 mt-1">
          <span className="text-[10px] text-gray-400">{new Date(msg.timestamp || Date.now()).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
          <CheckCheck className="w-3 h-3 text-blue-400" />
        </div>
      )}
    </div>
  </motion.div>
));

export const ChatMessageList = memo(({ messages, initialCount, sending }) => (
  <>
    {messages.map((msg, i) => <Bubble key={i} msg={msg} i={i} animate={i >= initialCount} />)}
    {sending && (
      <div className="flex justify-start">
        <img src="/logo.jpg" alt="" width="32" height="32" className="w-8 h-8 rounded-full object-cover mr-2 mt-1 shadow-sm" />
        <div className="chat-bubble-ai rounded-2xl rounded-bl-md px-4 py-3" data-testid="typing-indicator">
          <div className="flex gap-1.5">
            <span className="typing-dot w-2 h-2 rounded-full bg-gray-400" />
            <span className="typing-dot w-2 h-2 rounded-full bg-gray-400" />
            <span className="typing-dot w-2 h-2 rounded-full bg-gray-400" />
          </div>
        </div>
      </div>
    )}
  </>
));
